var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.canToggle
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.actionText,
                effect: "light",
                placement: "top",
                "open-delay": 400,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: {
                    "btn-secondary": !_vm.isBound,
                    "btn-danger": _vm.isBound,
                  },
                  on: { click: _vm.toggle },
                },
                [_c("i", { staticClass: "fas fa-link" })]
              ),
            ]
          )
        : _vm.isBound
        ? _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content: "Attached",
                placement: "top",
                "open-delay": 400,
              },
            },
            [_c("i", { staticClass: "fas fa-link" })]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }